import React from 'react';
import {
  IconButton,

  SvgIcon,
  Tooltip,
  
} from '@material-ui/core';

import {
    Bell as BellIcon,
  } from 'react-feather';



const Notifications = () => {





  return (
    <>
      <Tooltip title="Notifications">
        <IconButton
          style={{color:'#616161'}}
        
        >
       <SvgIcon fontSize="small">
            <BellIcon />
          </SvgIcon>
        </IconButton>
      </Tooltip>
    
    </>
  );
};

export default Notifications;
